import React from 'react';

import * as styles from './FacebookIcon.css';

export const FacebookIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.9999 10.0004C19.9999 4.47769 15.5222 0 9.99944 0C4.47671 0 -0.000976562 4.47769 -0.000976562 10.0004C-0.000976562 14.9923 3.65584 19.1291 8.43688 19.8792V12.8922H5.8976V10.0004H8.43688V7.79699C8.43688 5.29105 9.93027 3.90683 12.2145 3.90683C13.3079 3.90683 14.453 4.10184 14.453 4.10184V6.56277H13.1912C11.9487 6.56277 11.5612 7.33364 11.5612 8.1245V10.0004H14.3346L13.8913 12.8914H11.5612V19.8792C16.343 19.1291 19.9999 14.9923 19.9999 10.0004Z"
      className={styles.background}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.8923 12.8913L14.3357 10.0003H11.5622V8.12441C11.5622 7.33355 11.9497 6.56268 13.1923 6.56268H14.4532V4.10175C14.4532 4.10175 13.3081 3.90674 12.2148 3.90674C9.93049 3.90674 8.4371 5.29013 8.4371 7.7969V10.0003H5.89783V12.8913H8.4371V19.8791C9.47247 20.0416 10.5269 20.0416 11.5622 19.8791V12.8921H13.8923"
      className={styles.letter}
    />
  </svg>
);
